(() => {
  if (window.VastraaniiMediaLoading) return;

  // Keep server-rendered content and controls usable while only the photos load.
  const selector = [
    'custom-product-hero .vst-gallery-item > img',
    'custom-product-hero .vst-mob-media-slide > img',
    '.vst-gallery-thumbnail > img',
    '.vst-mob-thumbnail > img',
    '.vst-catalog .custom-card-image',
    '.vst-search-results .product-media__image',
    '.vst-search-results .card-gallery > img',
    '.vst-wishlist .wishlist-card-img',
    '.vst-rec-image-wrap > img',
    '.vpr__image',
    '.vbrand-card__media > a > img',
    '.vbrand-hero__photo img',
    '.vbrand-category__image img',
    '.vbrand-price-tile > img',
    '.vbrand-style-card__photo img',
    '.vshop-card__media > a > img',
  ].join(',');
  const states = new WeakMap();
  const visibleImages = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          target.toggleAttribute('data-vst-media-in-view', isIntersecting && states.get(target) === 'loading');
        });
      })
    : null;

  function setState(img, state) {
    if (states.get(img) === state) return;
    states.set(img, state);
    img.dataset.vstMediaState = state;
    if (state === 'loading') {
      if (visibleImages) visibleImages.observe(img);
      else img.setAttribute('data-vst-media-in-view', '');
    } else {
      visibleImages?.unobserve(img);
      img.removeAttribute('data-vst-media-in-view');
    }
  }

  function refreshImage(img) {
    if (!img.matches(selector)) return;
    // complete is also true for broken or empty images; never leave those shimmering.
    const hasSource = Boolean(img.currentSrc || img.getAttribute('src') || img.getAttribute('srcset'));
    setState(img, !hasSource || img.complete
      ? (img.naturalWidth > 0 ? 'ready' : 'error')
      : 'loading');
  }

  function visit(node, callback) {
    if (node.nodeType !== Node.ELEMENT_NODE && node !== document) return;
    if (node.matches?.(selector)) callback(node);
    node.querySelectorAll(selector).forEach(callback);
  }

  // Capture works for non-bubbling image events, including newly inserted cards.
  document.addEventListener('load', (event) => {
    if (event.target instanceof HTMLImageElement) refreshImage(event.target);
  }, true);
  document.addEventListener('error', (event) => {
    if (event.target instanceof HTMLImageElement && event.target.matches(selector)) {
      setState(event.target, 'error');
    }
  }, true);

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') {
        const img = record.target instanceof HTMLImageElement
          ? record.target
          : record.target.closest('picture')?.querySelector('img');
        if (img) refreshImage(img);
      } else {
        record.removedNodes.forEach((node) => visit(node, (img) => visibleImages?.unobserve(img)));
        record.addedNodes.forEach((node) => visit(node, (img) => {
          // A moved pending image must be observed again after removal.
          states.delete(img);
          refreshImage(img);
        }));
        if (record.target instanceof HTMLPictureElement) {
          const img = record.target.querySelector('img');
          if (img) refreshImage(img);
        }
      }
    });
  });

  document.documentElement.setAttribute('data-vst-media-loading', '');
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'sizes'],
  });
  visit(document, refreshImage);
  window.VastraaniiMediaLoading = { refresh: () => visit(document, refreshImage) };
})();
